import departureCity from './toRouter/departureCity';
import checkInDateRange from './toRouter/checkInDateRange';
import nightRange from './toRouter/nightRange';
import touristGroup from './toRouter/touristGroup';
import operators from './toRouter/operators';
import priceRange from './toRouter/priceRange';
import meals from './toRouter/meals';
import warranted from './toRouter/warranted';

export default (urlParams) => {
    const {
        tourCriteria,
        identity,
        activeTab,
        similar = false,
        sid,
        hsid,
    } = urlParams;

    let params = {
        ...departureCity(tourCriteria),
        ...checkInDateRange(tourCriteria),
        ...nightRange(tourCriteria),
        ...touristGroup(tourCriteria),
        ...operators(tourCriteria),
        ...warranted(tourCriteria),
    };

    if (!similar) {
        params = {
            ...params,
            ...priceRange(tourCriteria),
            ...meals(tourCriteria),
        };
    }

    if (identity) {
        params.identity = identity;
    }

    if (activeTab) {
        params.activeTab = activeTab;
    }

    if (sid) {
        params.sid = sid;
    }

    if (hsid) {
        params.hsid = hsid;
    }

    return params;
};